module.exports = __webpack_public_path__ + "static/img-not-found-white-0eb15c8119ea457285d2228978035df7.png";